// @owners { team: patients }
import { createSelector } from 'reselect';
import type { OrderPricingQueryData } from '~shared/queries/useOrderPricing';
import { type ReduxStateShared } from '~shared/types';

type UpdatedBelowMinProps = {
  initialQuantity: number;
  updatedQuantity: number;
  essentialPrice: number;
  minimumThresholdToWaiveFee: number;
  orderPricing?: OrderPricingQueryData;
};
const getInitialQuantity = (_: ReduxStateShared, props: UpdatedBelowMinProps) => props.initialQuantity;
const getUpdatedQuantity = (_: ReduxStateShared, props: UpdatedBelowMinProps) => props.updatedQuantity;
const getEssentialPrice = (_: ReduxStateShared, props: UpdatedBelowMinProps) => props.essentialPrice;
const getMinimumThresholdToWaiveFee = (_: ReduxStateShared, props: UpdatedBelowMinProps) =>
  props.minimumThresholdToWaiveFee;

const getOrderPricing = (_: ReduxStateShared, props: UpdatedBelowMinProps) => props.orderPricing;

export const getUpdatedEssentialQuantityIsBelowWaivedDeliveryFeeMin = createSelector(
  [getInitialQuantity, getUpdatedQuantity, getEssentialPrice, getMinimumThresholdToWaiveFee, getOrderPricing],
  (initialQuantity, updatedQuantity, essentialPrice, minimumThreshold, orderPricing): boolean => {
    const baseTotal = orderPricing?.line_items.find((line_item) => line_item.key === 'cash_price')?.value || 0;
    const insuranceCoveredTotal =
      orderPricing?.line_items.find((line_item) => line_item.key === 'insurance_paid')?.value || 0;
    const priceDiff = (initialQuantity - updatedQuantity) * essentialPrice;
    return baseTotal - insuranceCoveredTotal - priceDiff < minimumThreshold;
  },
);
